module.exports = __webpack_public_path__ + "media/images/lb/864-9c085f0e396702f7b231087a85de7b95.svg";